function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, message, InputNumber } from "antd";
import { Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AddProduct = function AddProduct(_ref) {
  var handler = _ref.handler,
    station = _ref.station;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([{
      label: "Carburant",
      value: 0
    }, {
      label: "Produits dérivés"
    }]),
    _useState8 = _slicedToArray(_useState7, 2),
    categoryOptions = _useState8[0],
    setCategoryOptions = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('user_id', Common.currentUser.id);
    formData.append('gas_station_id', station.id.toString());
    formData.append('available_quantity', values.available_quantity);
    formData.append('minimum_stock', values.minimum_stock);
    formData.append('category', values.category);
    formData.append('base_price', values.base_price);
    axios.post(Common.baseApiUrl + 'addproduct', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      category: 0
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "category",
            label: "Cat\xE9gorie",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: categoryOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "label",
            label: "D\xE9signation",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "base_price",
            label: "Prix de vente",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              style: {
                width: "95%"
              },
              suffix: "GNF",
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "available_quantity",
            label: "Qte Disponible",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              style: {
                width: "95%"
              },
              suffix: "L",
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "minimum_stock",
            label: "Stock Min.",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              style: {
                width: "95%"
              },
              suffix: "L",
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER"
          })
        })
      })]
    })]
  });
};
export default AddProduct;